
const AL = process.env.NODE_ENV !== 'production'
  ? process.env.VUE_APP_ASSETS_LOCATION || 'http://localhost:7001/'
  : '/'

const assetURL = (url = '') => {
  const appUrl = url && url.split('http://app:7001').pop()
  if (appUrl && appUrl.startsWith('http')) {
    return url
  }
  const alreadyHave = !!appUrl && appUrl.includes('http://localhost:7001/')
  const cleanURL = appUrl && appUrl.replace(/^\/+/g, '')
  return (AL && cleanURL && !alreadyHave) ? (AL + cleanURL) : appUrl
}

export default assetURL
